module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48ZGVmcz48c3R5bGU+LmF7ZmlsbDojMzQzYTQwO30uYntmaWxsOm5vbmU7fTwvc3R5bGU+PC9kZWZzPjxwYXRoIGNsYXNzPSJhIiBkPSJNMTAsMThoNFYxNkgxMFpNMyw2VjhIMjFWNlptMyw3SDE4VjExSDZaIi8+PHBhdGggY2xhc3M9ImIiIGQ9Ik0wLDBIMjRWMjRIMFoiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/faces/filter_list-24px.svg
// module id = 103
// module chunks = 0